import { useEffect, useRef } from 'react';

export function useClickOutside(onOutsideClick: (e: MouseEvent) => void) {
  const ref = useRef<any>(null);
  const triggerRef = useRef<any>(null);
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const isTarget =
        triggerRef.current?.contains(e?.target as Node) ||
        ref.current?.contains(e.target as Node);
      if (!isTarget) {
        onOutsideClick(e);
      }
      return;
    };

    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [ref, onOutsideClick]);

  return {
    ref,
    triggerRef,
  };
}
